import {Component, OnInit} from '@angular/core';
import {ClientConfigurationService, FeatureFlagService, SharedStateService} from '@twpub/core/services';
import {TITLE} from '@twpub/core/constants';
import {environment} from '../../../../environments/environment';
import {KeycloakService} from 'keycloak-angular';
import {SecurityConfigService} from '@twpub/shared/services/security-config.service';
import {MatSidenav, MatSidenavContainer, MatSidenavContent} from '@angular/material/sidenav';
import {
  MatDivider,
  MatListItem,
  MatListItemIcon,
  MatListItemTitle,
  MatListSubheaderCssMatStyler,
  MatNavList
} from '@angular/material/list';
import {RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {MatIcon} from '@angular/material/icon';

@Component({
  selector: 'pub-admin-page',
  templateUrl: './admin-page.component.html',
  styleUrls: ['./admin-page.component.scss'],
  standalone: true,
  imports: [MatSidenavContainer, MatSidenav, MatNavList, MatListSubheaderCssMatStyler, MatListItem, RouterLinkActive, RouterLink, MatIcon, MatListItemIcon, MatListItemTitle, MatDivider, MatSidenavContent, RouterOutlet]
})
export class AdminPageComponent implements OnInit {
  protected readonly title = TITLE;
  protected readonly versionStr = 'v' + environment.appVersion + '-' + environment.buildNumber;
  showMenu: boolean = false;
  configId: number | null = null;
  isConfigurationOk: boolean = false;
  canLogOut: boolean = false;
  isSuperAdmin: boolean = false;
  termSuggestionsEnabled: boolean = false;

  constructor(private configService: ClientConfigurationService,
              private kcService: KeycloakService, private sharedStateService: SharedStateService,
              private securityService: SecurityConfigService,
              private featureFlagService: FeatureFlagService) {
  }

  ngOnInit() {
    this.removeClientCss();
    this.checkTermWebConfiguration();
    this.configId = this.sharedStateService.getConfigId() || null;
    this.canLogOut = !this.securityService.isExternalAuth() || this.securityService.isKeycloakAdminMode();
    this.isSuperAdmin = this.securityService.isSuperAdmin();
    // Feature flags load asynchronously — wait for them so the Term Suggestions menu item
    // shows on a cold direct load of an admin URL (not only after navigating in).
    this.featureFlagService.waitForReady(() => {
      this.termSuggestionsEnabled = this.featureFlagService.isFeatureEnabled('TermSuggestions', false);
    });
  }

  private removeClientCss = () => {
    document.getElementById('clientConfigCss')?.remove();
  };

  private checkTermWebConfiguration() {
    this.configService.hasTermWebConfiguration().subscribe({
      next: () => {
        this.isConfigurationOk = true;
        this.showMenu = this.kcService.isLoggedIn();
      },
      error: () => {
        this.isConfigurationOk = false;
        this.showMenu = false;
      }
    });
  }

  async logoutUser() {
    await this.securityService.logoutUser();
  }
}
